import { LogObject, aiBenchmarkTestCompletedSrc156Evid4902Params, aiBenchmarkTestFailedSrc156Evid4903Params, aiBenchmarkTestStartedSrc156Evid4901Params, aiChatUoUActionsParams, aiChatUoUFormFillingStatusParams, aiChatUouActionsParams, aiUoUFormFillingLlmResponsePriceSrc156Evid4904Params, captchaEnforcerEventsParams, clickGenericParams, dummyNameParams, dummyNameSrc156Evid1Params, dummyNameSrc156Evid3000Params, dummyNameSrc156Evid3200Params, formBuilderBackofficeFormSubmissionFailedServerParams, formBuilderBackofficeFormSubmissionReceivedSuccessfullyServerParams, formBuilderBackofficeFormSubmissionSentServerParams, formBuilderFormCrudParams, formBuilderReportSpamParams, formBuilderSubmissionFailedParams, formBuilderSubmissionIgnoredParams, formBuilderSubmissionMarkedAsSpamParams, formBuilderSubmissionSentParams, formChatSettingsChangedSrc156Evid31Params, formComposerOpenedParams, formComposerSidebarActionParams, formComposerTopbarActionParams, formDesingSettingsChangedSrc156Evid30Params, formErrorAppearedDissapearedParams, formFieldCopyActionSrc156Evid32Params, formFieldCrudParams, formFieldEditAiParams, formFieldEditParams, formFieldEditPhoneFieldFlagParams, formFieldFocusParams, formFieldSettingsChangedParams, formListErrorShownParams, formListFilterActionParams, formListOpenedParams, formSubmissionParams, formUoUButtonClickGenericSrc156Evid1008Params, formViewParams, formWidgetCrudParams, formsActionsAfterSubmissionsContactCreatedParams, formsActionsAfterSubmissionsSubmissionProcessedParams, formsEmailOpensFormSubmissionEmailsParams, formsPaymentFormUserConnectPaymentToAFormParams, formsSettingsChangedParams, inputElementsAppointmentFieldSettingsChangeValueParams, inputElementsAppointmentFieldSettingsClickOnButtonParams, membersClickOnSaveInTheChangeSiteMemberLoginEmailModalParams, modalActionGenericParams, modalShownGenericParams, oneAppFormManageActionClickParams, oneAppFormTemplateChosenParams, oneAppSubmissionViewOpenedDeprecatedParams, oneAppSubmissionViewOpenedSrc156Evid3218Params, oneAppSubmissionsTableOpenedParams, oneAppSubmissionsTableTabOpenedParams, oneAppSubmissionsTableTabOpenedSrc156Evid3217Params, publishedFormsWidgetsParams, spamFilterManageParams, submissionHoverSrc156Evid3222Params, submissionPassedValidationParams, submitFormClickParams, widgetConnectedToFormSchemaParams, wildFormsTemplatesPageAboveTheFoldImpressionSrc156Evid5252Params, wildFormsTemplatesPageEditTemplateSrc156Evid5215Params, wildFormsTemplatesPageFilterInteractionsSrc156Evid5226Params, wildFormsTemplatesPageGeneralActionSrc156Evid5242Params, wildFormsTemplatesPageHoverTemplateSrc156Evid5212Params, wildFormsTemplatesPageMenuInteractionsSrc156Evid5225Params, wildFormsTemplatesPageNavigationSrc156Evid5254Params, wildFormsTemplatesPagePageViewSrc156Evid5201Params, wildFormsTemplatesPagePageViewSrc181Evid5201Params, wildFormsTemplatesPagePaginationSrc156Evid5255Params, wildFormsTemplatesPageSearchSrc156Evid5224Params } from '../types';

/**
 * A function to create a log object for the 'dummyNameSrc156Evid1' event (evid: 1)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc156Evid1Params} params - The parameters for this event
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @return {LogObject<dummyNameSrc156Evid1Params>} LogObject<dummyNameSrc156Evid1Params>
 */
export function dummyNameSrc156Evid1(params: dummyNameSrc156Evid1Params): LogObject<dummyNameSrc156Evid1Params> {
  return { evid: 1, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'dummyName' event (evid: 1000)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params: dummyNameParams): LogObject<dummyNameParams> {
  return { evid: 1000, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formView' event (evid: 1001)
 *
 * Event description: Form Viewed by UoU
 *
 * @param {formViewParams} params - The parameters for this event
 * @property {string} form_filling_id - form_filling_id
 * @property {string} form_schema_name - form schema name
 * @property {string} form_url - form url
 * @property {string} form_type - form expression (web, standalone, etc.)
 * @property {string} mode - preview/live site
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @property {string} filling_method - chat or classic, for standalone
 * @return {LogObject<formViewParams>} LogObject<formViewParams>
 */
export function formView(params: formViewParams): LogObject<formViewParams> {
  return { evid: 1001, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formFieldEdit' event (evid: 1002)
 *
 * Event description: UoU started filling in fields
 *
 * @param {formFieldEditParams} params - The parameters for this event
 * @property {string} field_label - id
 * @property {string} form_schema_name - form schama name
 * @property {string} field_id - field_id
 * @property {string} form_url - form url
 * @property {string} field_target - id: field_target
 * @property {string} form_type - form expression (web, standalone, etc.)
 * @property {GUID} form_guid - form_guid
 * @property {string} form_fill_session_id - unique id which defines particular form fill session
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @property {string} filling_method - chat or classic, for standalone
 * @return {LogObject<formFieldEditParams>} LogObject<formFieldEditParams>
 */
export function formFieldEdit(params: formFieldEditParams): LogObject<formFieldEditParams> {
  return { evid: 1002, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'submitFormClick' event (evid: 1003)
 *
 * Event description: Form Submitted
 *
 * @param {submitFormClickParams} params - The parameters for this event
 * @property {string} form_schema_name - form schema name
 * @property {string} submission_status - Success/Failed
 * @property {string} form_url - form url
 * @property {string} error_reason - Error reason if failed
 * @property {GUID} form_guid - form_guid
 * @property {string} error_message - Full error message
 * @property {string} form_fill_session_id - unique id which defines particular form fill session
 * @property {string} namespace - namespace
 * @property {GUID} submission_id - submission id
 * @property {boolean} is_standalone - is standalone form
 * @property {string} filling_method - chat or classic, for standalone
 * @property {string} referral_info - Where submission was made from (website form, ai assistant, etc)
 * @return {LogObject<submitFormClickParams>} LogObject<submitFormClickParams>
 */
export function submitFormClick(params: submitFormClickParams): LogObject<submitFormClickParams> {
  return { evid: 1003, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formFieldFocus' event (evid: 1004)
 *
 * Event description: Form field was focused
 *
 * @param {formFieldFocusParams} params - The parameters for this event
 * @property {string} field_label - id
 * @property {string} form_schema_name - form schama name
 * @property {string} field_id - field id
 * @property {string} form_url - form url
 * @property {string} field_target - id
 * @property {GUID} form_guid - form schema id
 * @property {string} action_type - blur/focus
 * @property {string} form_fill_session_id - unique id which defines particular form fill session
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @property {string} filling_method - chat or classic, for standalone
 * @return {LogObject<formFieldFocusParams>} LogObject<formFieldFocusParams>
 */
export function formFieldFocus(params: formFieldFocusParams): LogObject<formFieldFocusParams> {
  return { evid: 1004, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formErrorAppearedDissapeared' event (evid: 1006)
 *
 * Event description: For error appeared or dissapeared
 *
 * @param {formErrorAppearedDissapearedParams} params - The parameters for this event
 * @property {string} field_label - id
 * @property {string} form_schema_name - Form schema name
 * @property {string} field_id - field id
 * @property {string} form_url - form url
 * @property {string} field_target - id
 * @property {GUID} form_guid - form schema id
 * @property {string} field_name - name of the field in schema
 * @property {string} action_type - appeared/dissapeared
 * @property {string} form_fill_session_id - unique id which defines particular form fill session
 * @property {string} error_name - description of the error appeared
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @property {string} filling_method - chat or classic, for standalone
 * @return {LogObject<formErrorAppearedDissapearedParams>} LogObject<formErrorAppearedDissapearedParams>
 */
export function formErrorAppearedDissapeared(params: formErrorAppearedDissapearedParams): LogObject<formErrorAppearedDissapearedParams> {
  return { evid: 1006, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formFieldEditPhoneFieldFlag' event (evid: 1007)
 *
 * Event description: UoU changed Phone Field flag
 *
 * @param {formFieldEditPhoneFieldFlagParams} params - The parameters for this event
 * @property {string} field_label - id
 * @property {string} form_schema_name - form schama name
 * @property {string} field_id - field_id
 * @property {string} form_url - form url
 * @property {string} field_target - id: field_target
 * @property {string} form_type - form expression (web, standalone, etc.)
 * @property {GUID} form_guid - form_guid
 * @property {string} form_fill_session_id - unique id which defines particular form fill session
 * @property {string} namespace - namespace
 * @property {string} flag_country_code - flag country code
 * @property {string} flag_set_method - automatic/manual - how the flag was changed
 * @property {string} phone_country_code - phone country code
 * @property {boolean} is_phone_field_filled - is phone field  itself filled
 * @property {boolean} is_standalone - is standalone form
 * @property {string} filling_method - chat or classic, for standalone
 * @return {LogObject<formFieldEditPhoneFieldFlagParams>} LogObject<formFieldEditPhoneFieldFlagParams>
 */
export function formFieldEditPhoneFieldFlag(params: formFieldEditPhoneFieldFlagParams): LogObject<formFieldEditPhoneFieldFlagParams> {
  return { evid: 1007, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formUoUButtonClickGenericSrc156Evid1008' event (evid: 1008)
 *
 * Event description: Form UoU button click generic event
 *
 * @param {formUoUButtonClickGenericSrc156Evid1008Params} params - The parameters for this event
 * @property {string} form_filling_id - form_filling_id
 * @property {string} form_schema_name - form schema name
 * @property {string} form_url - form url
 * @property {string} form_type - form expression (web, standalone, etc.)
 * @property {string} mode - preview/live site
 * @property {GUID} form_guid - form_guid if relevant
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @property {string} filling_method - chat or classic, for standalone
 * @property {string} field_id - field_id if relevant
 * @property {string} name - button name (E.g. Chat/Form/Microphone)
 * @property {string} parent_name - Section name,  e.g. Classic-Chat view toggle, Input message bar, etc.
 * @return {LogObject<formUoUButtonClickGenericSrc156Evid1008Params>} LogObject<formUoUButtonClickGenericSrc156Evid1008Params>
 */
export function formUoUButtonClickGenericSrc156Evid1008(params: formUoUButtonClickGenericSrc156Evid1008Params): LogObject<formUoUButtonClickGenericSrc156Evid1008Params> {
  return { evid: 1008, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formComposerTopbarAction' event (evid: 11)
 *
 * Event description: tab selected in form composer on the Top (edit, preview, submissions, click on form name, settings, etc)
 *
 * @param {formComposerTopbarActionParams} params - The parameters for this event
 * @property {string} tab_name - Edit, Settings, Preview, Submissions, click on form name, back, etc
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<formComposerTopbarActionParams>} LogObject<formComposerTopbarActionParams>
 */
export function formComposerTopbarAction(params: formComposerTopbarActionParams): LogObject<formComposerTopbarActionParams> {
  return { evid: 11, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formComposerOpened' event (evid: 14)
 *
 * Event description: form composer fully loaded
 *
 * @param {formComposerOpenedParams} params - The parameters for this event
 * @property {string} tab_name - Nice to have: Tab name which is opened on ompening composer event
 * @property {boolean} is_new - true if new form
 * @property {string} origin - where form composer was opened from
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<formComposerOpenedParams>} LogObject<formComposerOpenedParams>
 */
export function formComposerOpened(params: formComposerOpenedParams): LogObject<formComposerOpenedParams> {
  return { evid: 14, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formFieldCrud' event (evid: 15)
 *
 * Event description: Form Field Added - add a field to form
 * Form Field Removed - remove a field from form
 * Form Field Deleted - delete a removed field permanently
 *
 * @param {formFieldCrudParams} params - The parameters for this event
 * @property {string} field_type - e.g. Text, Image, etc.
 * @property {string} add_action - click/drag_and_drop/duplicate/restored
 * @property {GUID} field_id - field id, unique per form
 * @property {string} field_target - id
 * @property {GUID} form_guid - form_guid
 * @property {string} error_message - error message if any
 * @property {string} field_json - field value in json
 * @property {string} action - add, move to trash, delete
 * @property {boolean} is_error - True if error
 * @property {string} namespace - namespace
 * @property {string} origin - origin - AI Chat / Add panel / something else
 * @property {string} ai_conversation_id - ai_conversation_id for AI Assistant
 * @property {boolean} is_standalone - is standalone form
 * @property {string} action_detail - detailed action, for example "paste" on "add" action. Or "cut" on "delete" action
 * @return {LogObject<formFieldCrudParams>} LogObject<formFieldCrudParams>
 */
export function formFieldCrud(params: formFieldCrudParams): LogObject<formFieldCrudParams> {
  return { evid: 15, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formComposerSidebarAction' event (evid: 16)
 *
 * Event description: tab selected in form composer
 *
 * @param {formComposerSidebarActionParams} params - The parameters for this event
 * @property {string} tab_name - Add, Settings, Rules, etc.
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<formComposerSidebarActionParams>} LogObject<formComposerSidebarActionParams>
 */
export function formComposerSidebarAction(params: formComposerSidebarActionParams): LogObject<formComposerSidebarActionParams> {
  return { evid: 16, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'clickGeneric' event (evid: 200)
 *
 * Event description: generic event to record click actions: to add 1. edit/settings/help/three dots form click in the editor 2. Clicks after three dots in the editor 3. Create form click from settings widget
 *
 * @param {clickGenericParams} params - The parameters for this event
 * @property {string} area - Submissions table, Forms List, etc
 * @property {string} name - button name of the click
 * @property {string} parent_name - for dropdowns, name of the dropdown
 * @property {string} relevant_ids_json - nice to have: if there are extra relevant ids, e.g. {form_guid: 123}
 * @property {string} field_id - field_id if relevant
 * @property {string} field_target - field_target if relevant
 * @property {GUID} form_guid - form_guid if relevant
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<clickGenericParams>} LogObject<clickGenericParams>
 */
export function clickGeneric(params: clickGenericParams): LogObject<clickGenericParams> {
  return { evid: 200, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formBuilderFormCrud' event (evid: 2001)
 *
 * Event description: Form Created - create a form
 * Form Saved - save a form
 * Form Removed - remove a form
 * Form Deleted - permanently delete a form
 *
 * @param {formBuilderFormCrudParams} params - The parameters for this event
 * @property {string} form_schema_name - form schema name
 * @property {GUID} meta_site_id - msid
 * @property {string} form_url - url where form is installed
 * @property {string} kinds - automation, migration, regular
 * @property {GUID} form_guid - form_guid
 * @property {string} template - Only for create action (raw template name)
 * @property {GUID} original_form_id - applicable on duplicate
 * @property {string} action - create, update, moveToTrash, restoreFromTrash, deletePermanently, duplicate
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @property {string} formType - payment form / file upload form
 * @return {LogObject<formBuilderFormCrudParams>} LogObject<formBuilderFormCrudParams>
 */
export function formBuilderFormCrud(params: formBuilderFormCrudParams): LogObject<formBuilderFormCrudParams> {
  return { evid: 2001, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'modalShownGeneric' event (evid: 201)
 *
 * Event description: Used for modals in Forms.
 * Modals:
 * -Export Forms Submissions
 * -Save view
 *
 * @param {modalShownGenericParams} params - The parameters for this event
 * @property {string} relevant_ids_json - if there are extra relevant ids, e.g. {view_id: 123}
 * @property {string} field_id - field_id if relevant
 * @property {string} modal_name - e.g. "Export to CSV file", "Which Items you want to export", "Save view", etc
 * @property {string} flow_name - e.g. "Export Forms", "Save View
 * @property {string} origin - origin
 * @property {string} field_target - field_target if relevant
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<modalShownGenericParams>} LogObject<modalShownGenericParams>
 */
export function modalShownGeneric(params: modalShownGenericParams): LogObject<modalShownGenericParams> {
  return { evid: 201, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'modalActionGeneric' event (evid: 202)
 *
 * Event description: Used for modals in Forms.
 * Modals:
 * -Export Forms Submissions
 *
 * @param {modalActionGenericParams} params - The parameters for this event
 * @property {string} choices_json - json of choices, e.g. {view_id: 123, export_items: view} or {view_name: "My first view"}
 * @property {string} modal_action - e.g. cancel/close/export/next/etc
 * @property {string} relevant_ids_json - if there are extra relevant ids, e.g. {view_id: 123}
 * @property {string} field_id - field_id if relevant
 * @property {string} modal_name - e.g. "Export to CSV file", "Which Items you want to export", "Save view", etc
 * @property {string} flow_name - e.g. "Export Forms", "Save View
 * @property {string} origin - origin
 * @property {string} field_target - field_target if relevant
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<modalActionGenericParams>} LogObject<modalActionGenericParams>
 */
export function modalActionGeneric(params: modalActionGenericParams): LogObject<modalActionGenericParams> {
  return { evid: 202, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formFieldSettingsChanged' event (evid: 24)
 *
 * Event description: form field settings changed
 *
 * @param {formFieldSettingsChangedParams} params - The parameters for this event
 * @property {GUID} field_id - field id
 * @property {string} setting_input_json - setting input in json
 * @property {string} field_target - field_target
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<formFieldSettingsChangedParams>} LogObject<formFieldSettingsChangedParams>
 */
export function formFieldSettingsChanged(params: formFieldSettingsChangedParams): LogObject<formFieldSettingsChangedParams> {
  return { evid: 24, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oneAppFormManageActionClick' event (evid: 27)
 *
 * Event description: Action in Form Manage tab in OneApp
 *
 * @param {oneAppFormManageActionClickParams} params - The parameters for this event
 * @property {string} button_name - button_name
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @return {LogObject<oneAppFormManageActionClickParams>} LogObject<oneAppFormManageActionClickParams>
 */
export function oneAppFormManageActionClick(params: oneAppFormManageActionClickParams): LogObject<oneAppFormManageActionClickParams> {
  return { evid: 27, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oneAppFormTemplateChosen' event (evid: 28)
 *
 * Event description: Chosen Form Template in create new form flow on OneApp
 *
 * @param {oneAppFormTemplateChosenParams} params - The parameters for this event
 * @property {string} template_name - template_name
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {string} template_id - template_id
 * @return {LogObject<oneAppFormTemplateChosenParams>} LogObject<oneAppFormTemplateChosenParams>
 */
export function oneAppFormTemplateChosen(params: oneAppFormTemplateChosenParams): LogObject<oneAppFormTemplateChosenParams> {
  return { evid: 28, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formsSettingsChanged' event (evid: 29)
 *
 * Event description: Forms settings changed (name, spam filter, required field display, etc.)
 *
 * @param {formsSettingsChangedParams} params - The parameters for this event
 * @property {string} setting_input_json - setting input in json
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<formsSettingsChangedParams>} LogObject<formsSettingsChangedParams>
 */
export function formsSettingsChanged(params: formsSettingsChangedParams): LogObject<formsSettingsChangedParams> {
  return { evid: 29, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formDesingSettingsChangedSrc156Evid30' event (evid: 30)
 *
 * Event description: form Design settings changed in Form Composer
 *
 * @param {formDesingSettingsChangedSrc156Evid30Params} params - The parameters for this event
 * @property {string} setting_input_json - setting input in json
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<formDesingSettingsChangedSrc156Evid30Params>} LogObject<formDesingSettingsChangedSrc156Evid30Params>
 */
export function formDesingSettingsChangedSrc156Evid30(params: formDesingSettingsChangedSrc156Evid30Params): LogObject<formDesingSettingsChangedSrc156Evid30Params> {
  return { evid: 30, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'dummyNameSrc156Evid3000' event (evid: 3000)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc156Evid3000Params} params - The parameters for this event
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @return {LogObject<dummyNameSrc156Evid3000Params>} LogObject<dummyNameSrc156Evid3000Params>
 */
export function dummyNameSrc156Evid3000(params: dummyNameSrc156Evid3000Params): LogObject<dummyNameSrc156Evid3000Params> {
  return { evid: 3000, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formSubmission' event (evid: 3001)
 *
 * Event description: Form Submitted
 *
 * @param {formSubmissionParams} params - The parameters for this event
 * @property {string} form_schema_name - form schema name
 * @property {string} failure_reason - Failure reason
 * @property {string} url - url where form is installed
 * @property {GUID} meta_site_id - msid
 * @property {GUID} submissionId - submission_id
 * @property {boolean} captcha_success - true - success, false - failed, null - doesn't have captcha
 * @property {string} failure_reason_details - Failure reason details
 * @property {string} submission_status - status
 * @property {string} kinds - automation, migration, regular
 * @property {number} num_of_fields - number of fields filled-in in the form submission
 * @property {string} spam_submission_id - spam_submission_id, not null if spam
 * @property {string} form_type - form expression (standalone, web, etc.)
 * @property {GUID} form_guid - form_guid
 * @property {number} num_of_attachments - number of attachments in the form
 * @property {string} contact_id - contact_id when this value is mapped in the submission
 * @property {boolean} is_bulk_action - true if the action was bulk (e.g. bulk move to trash)
 * @property {string} email_hash - email hash
 * @property {string} action_type - created, updated, contact_id_map, deleted, report as spam, and more
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<formSubmissionParams>} LogObject<formSubmissionParams>
 */
export function formSubmission(params: formSubmissionParams): LogObject<formSubmissionParams> {
  return { evid: 3001, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formChatSettingsChangedSrc156Evid31' event (evid: 31)
 *
 * Event description: form Chat settings changed in Form Composer
 *
 * @param {formChatSettingsChangedSrc156Evid31Params} params - The parameters for this event
 * @property {string} setting_input_json - setting input in json
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<formChatSettingsChangedSrc156Evid31Params>} LogObject<formChatSettingsChangedSrc156Evid31Params>
 */
export function formChatSettingsChangedSrc156Evid31(params: formChatSettingsChangedSrc156Evid31Params): LogObject<formChatSettingsChangedSrc156Evid31Params> {
  return { evid: 31, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formFieldCopyActionSrc156Evid32' event (evid: 32)
 *
 * Event description: Form Field Copy Action
 *
 * @param {formFieldCopyActionSrc156Evid32Params} params - The parameters for this event
 * @property {GUID} form_guid - form_guid
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @property {string} field_id - origin_field_id
 * @property {string} field_type - origin_field_type
 * @property {string} source - "contextual_menu", "action_bar", "keyboard_shortcut"
 * @return {LogObject<formFieldCopyActionSrc156Evid32Params>} LogObject<formFieldCopyActionSrc156Evid32Params>
 */
export function formFieldCopyActionSrc156Evid32(params: formFieldCopyActionSrc156Evid32Params): LogObject<formFieldCopyActionSrc156Evid32Params> {
  return { evid: 32, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'dummyNameSrc156Evid3200' event (evid: 3200)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc156Evid3200Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc156Evid3200Params>} LogObject<dummyNameSrc156Evid3200Params>
 */
export function dummyNameSrc156Evid3200(params: dummyNameSrc156Evid3200Params): LogObject<dummyNameSrc156Evid3200Params> {
  return { evid: 3200, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formListOpened' event (evid: 3204)
 *
 * Event description: Form list opened
 *
 * @param {formListOpenedParams} params - The parameters for this event
 * @return {LogObject<formListOpenedParams>} LogObject<formListOpenedParams>
 */
export function formListOpened(params: formListOpenedParams): LogObject<formListOpenedParams> {
  return { evid: 3204, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formListFilterAction' event (evid: 3206)
 *
 * Event description: Form list filter action.
 *
 * @param {formListFilterActionParams} params - The parameters for this event
 * @property {string} filterBy - all_forms/active_forms/deleted_forms
 * @return {LogObject<formListFilterActionParams>} LogObject<formListFilterActionParams>
 */
export function formListFilterAction(params: formListFilterActionParams): LogObject<formListFilterActionParams> {
  return { evid: 3206, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formListErrorShown' event (evid: 3210)
 *
 * Event description: Error shown inside form list
 *
 * @param {formListErrorShownParams} params - The parameters for this event
 * @property {string} error_type - error type
 * @property {string} error_message - error_message
 * @property {number} error_code - http code
 * @return {LogObject<formListErrorShownParams>} LogObject<formListErrorShownParams>
 */
export function formListErrorShown(params: formListErrorShownParams): LogObject<formListErrorShownParams> {
  return { evid: 3210, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'widgetConnectedToFormSchema' event (evid: 3211)
 *
 * Event description: User changed which form connected to Widget
 *
 * @param {widgetConnectedToFormSchemaParams} params - The parameters for this event
 * @property {GUID} widget_id - widget_id
 * @property {GUID} form_guid - form_guid to which widget is connected
 * @property {GUID} form_guid_disconnected - (nice to have) form guid from which widget was disconnected
 * @property {string} component_id - unique, to identify specific widget (maybe something else can be used? How do you identify it in FE?)
 * @property {string} namespace - namespace
 * @return {LogObject<widgetConnectedToFormSchemaParams>} LogObject<widgetConnectedToFormSchemaParams>
 */
export function widgetConnectedToFormSchema(params: widgetConnectedToFormSchemaParams): LogObject<widgetConnectedToFormSchemaParams> {
  return { evid: 3211, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formWidgetCrud' event (evid: 3212)
 *
 * Event description: User added or removed widget from editor
 *
 * @param {formWidgetCrudParams} params - The parameters for this event
 * @property {GUID} widget_id - widget_id
 * @property {GUID} biToken - msid
 * @property {string} origin - add panel
 * @property {GUID} form_guid - form_guid to which widget is connected
 * @property {string} template - Template name (blank, contactUs, subscribe, etc)
 * @property {string} component_id - unique, to identify specific widget (maybe something else can be used? How do you identify it in FE?)
 * @property {string} action - added/removed
 * @property {string} namespace - namespace
 * @return {LogObject<formWidgetCrudParams>} LogObject<formWidgetCrudParams>
 */
export function formWidgetCrud(params: formWidgetCrudParams): LogObject<formWidgetCrudParams> {
  return { evid: 3212, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'publishedFormsWidgets' event (evid: 3213)
 *
 * Event description: Tells which widgets are published and to which form ids each widget is connected on site publish
 *
 * @param {publishedFormsWidgetsParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {string} forms_object - array of forms with form_id (guid), wdiget_id, component_id, page_id
 * @property {string} namespace - namespace
 * @return {LogObject<publishedFormsWidgetsParams>} LogObject<publishedFormsWidgetsParams>
 */
export function publishedFormsWidgets(params: publishedFormsWidgetsParams): LogObject<publishedFormsWidgetsParams> {
  return { evid: 3213, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oneAppSubmissionsTableOpened' event (evid: 3214)
 *
 * Event description: Opened sibmissions table of a Form in OneApp
 *
 * @param {oneAppSubmissionsTableOpenedParams} params - The parameters for this event
 * @property {string} formGuid - form_guid	
 * @property {string} namespace - namespace
 * @property {string} origin - origin
 * @return {LogObject<oneAppSubmissionsTableOpenedParams>} LogObject<oneAppSubmissionsTableOpenedParams>
 */
export function oneAppSubmissionsTableOpened(params: oneAppSubmissionsTableOpenedParams): LogObject<oneAppSubmissionsTableOpenedParams> {
  return { evid: 3214, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oneAppSubmissionsTableTabOpened' event (evid: 3215)
 *
 * Event description: Trash/Spam/Submissions
 *
 * @param {oneAppSubmissionsTableTabOpenedParams} params - The parameters for this event
 * @property {string} formGuid - form_guid	
 * @property {string} namespace - namespace
 * @property {string} origin - origin
 * @property {string} tabName - Trash/Spam/Submissions
 * @return {LogObject<oneAppSubmissionsTableTabOpenedParams>} LogObject<oneAppSubmissionsTableTabOpenedParams>
 */
export function oneAppSubmissionsTableTabOpened(params: oneAppSubmissionsTableTabOpenedParams): LogObject<oneAppSubmissionsTableTabOpenedParams> {
  return { evid: 3215, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oneAppSubmissionViewOpenedDeprecated' event (evid: 3216)
 *
 * Event description: Opened specific submission
 *
 * @param {oneAppSubmissionViewOpenedDeprecatedParams} params - The parameters for this event
 * @property {string} formGuid - form_guid	
 * @property {string} namespace - namespace
 * @property {string} origin - origin
 * @property {string} tabName - nice to have: tab name the submission is inside: Trash/Spam/Submissions
 * @property {GUID} submissionid - Submission id
 * @return {LogObject<oneAppSubmissionViewOpenedDeprecatedParams>} LogObject<oneAppSubmissionViewOpenedDeprecatedParams>
 */
export function oneAppSubmissionViewOpenedDeprecated(params: oneAppSubmissionViewOpenedDeprecatedParams): LogObject<oneAppSubmissionViewOpenedDeprecatedParams> {
  return { evid: 3216, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oneAppSubmissionsTableTabOpenedSrc156Evid3217' event (evid: 3217)
 *
 * Event description: Trash/Spam/Submissions
 *
 * @param {oneAppSubmissionsTableTabOpenedSrc156Evid3217Params} params - The parameters for this event
 * @property {string} formGuid - form_guid
 * @property {string} tabName - Trash/Spam/Submissions
 * @property {string} origin - origin
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<oneAppSubmissionsTableTabOpenedSrc156Evid3217Params>} LogObject<oneAppSubmissionsTableTabOpenedSrc156Evid3217Params>
 */
export function oneAppSubmissionsTableTabOpenedSrc156Evid3217(params: oneAppSubmissionsTableTabOpenedSrc156Evid3217Params): LogObject<oneAppSubmissionsTableTabOpenedSrc156Evid3217Params> {
  return { evid: 3217, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'oneAppSubmissionViewOpenedSrc156Evid3218' event (evid: 3218)
 *
 * Event description: Opened specific submission
 *
 * @param {oneAppSubmissionViewOpenedSrc156Evid3218Params} params - The parameters for this event
 * @property {string} formGuid - form_guid
 * @property {string} tabName - nice to have: tab name the submission is inside: Trash/Spam/Submissions
 * @property {string} origin - origin
 * @property {GUID} submissionid - submission_id
 * @property {string} namespace - namespace
 * @property {boolean} is_standalone - is standalone form
 * @return {LogObject<oneAppSubmissionViewOpenedSrc156Evid3218Params>} LogObject<oneAppSubmissionViewOpenedSrc156Evid3218Params>
 */
export function oneAppSubmissionViewOpenedSrc156Evid3218(params: oneAppSubmissionViewOpenedSrc156Evid3218Params): LogObject<oneAppSubmissionViewOpenedSrc156Evid3218Params> {
  return { evid: 3218, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'aiChatUoUActions' event (evid: 3219)
 *
 * Event description: Actions of UoU while filling the form through chat - open, close, send message
 *
 * @param {aiChatUoUActionsParams} params - The parameters for this event
 * @property {GUID} form_guid - form_guid
 * @property {string} action - open/close/send message
 * @property {string} form_fill_session_id - session for form filling (if possible)
 * @property {string} fieldsTotal - Total fields in a form
 * @property {string} fieldsFilled - Fields filled by AI assistant in a form
 * @return {LogObject<aiChatUoUActionsParams>} LogObject<aiChatUoUActionsParams>
 */
export function aiChatUoUActions(params: aiChatUoUActionsParams): LogObject<aiChatUoUActionsParams> {
  return { evid: 3219, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'aiChatUoUFormFillingStatus' event (evid: 3220)
 *
 * Event description: Actions of UoU while filling the form through chat - open, close, send message
 *
 * @param {aiChatUoUFormFillingStatusParams} params - The parameters for this event
 * @property {GUID} form_guid - form_guid
 * @property {string} fieldsFilled - how many fields were filled by AI
 * @property {string} form_fill_session_id - session for form filling (if possible)
 * @property {string} fieldsTotal - total amount of fields in a form
 * @return {LogObject<aiChatUoUFormFillingStatusParams>} LogObject<aiChatUoUFormFillingStatusParams>
 */
export function aiChatUoUFormFillingStatus(params: aiChatUoUFormFillingStatusParams): LogObject<aiChatUoUFormFillingStatusParams> {
  return { evid: 3220, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'aiChatUouActions' event (evid: 3221)
 *
 * Event description: Actions of UoU while filling the form through chat - open, close, send message
 *
 * @param {aiChatUouActionsParams} params - The parameters for this event
 * @property {string} fieldsFilled - Fields filled by AI assistant in a form
 * @property {string} errorMessage - Error message if error
 * @property {string} field_id - field_id
 * @property {GUID} form_guid - form_guid
 * @property {string} fieldsTotal - Total fields in a form
 * @property {string} form_fill_session_id - session for form filling (if possible)
 * @property {string} action - open/close/send/error message
 * @property {string} namespace - namespace
 * @return {LogObject<aiChatUouActionsParams>} LogObject<aiChatUouActionsParams>
 */
export function aiChatUouActions(params: aiChatUouActionsParams): LogObject<aiChatUouActionsParams> {
  return { evid: 3221, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'submissionHoverSrc156Evid3222' event (evid: 3222)
 *
 * Event description: Hover on submission in submissions table
 *
 * @param {submissionHoverSrc156Evid3222Params} params - The parameters for this event
 * @property {string} formGuid - form_guid
 * @property {string} tabName - nice to have: tab name the submission is inside: Trash/Spam/Submissions
 * @property {string} origin - origin
 * @property {GUID} submissionid - submission_id
 * @property {string} namespace - namespace
 * @return {LogObject<submissionHoverSrc156Evid3222Params>} LogObject<submissionHoverSrc156Evid3222Params>
 */
export function submissionHoverSrc156Evid3222(params: submissionHoverSrc156Evid3222Params): LogObject<submissionHoverSrc156Evid3222Params> {
  return { evid: 3222, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formFieldEditAi' event (evid: 3224)
 *
 * Event description: UoU edited form field, array of fields (as AI can edit multiple fields)
 *
 * @param {formFieldEditAiParams} params - The parameters for this event
 * @property {string} fieldLabelArray - field_label array
 * @property {string} form_schema_name - form_schema_name
 * @property {string} fieldIdArray - field_id array
 * @property {string} form_url - form_url
 * @property {string} fieldTargetArray - field_target array
 * @property {string} form_type - form_type
 * @property {GUID} form_guid - form_guid
 * @property {string} form_fill_session_id - form_fill_session_id
 * @property {string} namespace - namespace
 * @return {LogObject<formFieldEditAiParams>} LogObject<formFieldEditAiParams>
 */
export function formFieldEditAi(params: formFieldEditAiParams): LogObject<formFieldEditAiParams> {
  return { evid: 3224, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'aiBenchmarkTestStartedSrc156Evid4901' event (evid: 4901)
 *
 * Event description: For testing AI generation
 *
 * @param {aiBenchmarkTestStartedSrc156Evid4901Params} params - The parameters for this event
 * @property {GUID} testExecutionId - uuid
 * @property {string} testName - name of test
 * @property {boolean} executedInCi - true/false
 * @return {LogObject<aiBenchmarkTestStartedSrc156Evid4901Params>} LogObject<aiBenchmarkTestStartedSrc156Evid4901Params>
 */
export function aiBenchmarkTestStartedSrc156Evid4901(params: aiBenchmarkTestStartedSrc156Evid4901Params): LogObject<aiBenchmarkTestStartedSrc156Evid4901Params> {
  return { evid: 4901, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'aiBenchmarkTestCompletedSrc156Evid4902' event (evid: 4902)
 *
 * Event description: For testing AI generation
 *
 * @param {aiBenchmarkTestCompletedSrc156Evid4902Params} params - The parameters for this event
 * @property {GUID} testExecutionId - uuid
 * @property {string} testName - name of test
 * @property {boolean} executedInCi - true/false
 * @property {string} llmResponse - llm response
 * @return {LogObject<aiBenchmarkTestCompletedSrc156Evid4902Params>} LogObject<aiBenchmarkTestCompletedSrc156Evid4902Params>
 */
export function aiBenchmarkTestCompletedSrc156Evid4902(params: aiBenchmarkTestCompletedSrc156Evid4902Params): LogObject<aiBenchmarkTestCompletedSrc156Evid4902Params> {
  return { evid: 4902, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'aiBenchmarkTestFailedSrc156Evid4903' event (evid: 4903)
 *
 * Event description: For testing AI generation
 *
 * @param {aiBenchmarkTestFailedSrc156Evid4903Params} params - The parameters for this event
 * @property {GUID} testExecutionId - uuid
 * @property {string} testName - name of test
 * @property {boolean} executedInCi - true/false
 * @property {string} llmResponse - llm response
 * @property {string} error - error
 * @return {LogObject<aiBenchmarkTestFailedSrc156Evid4903Params>} LogObject<aiBenchmarkTestFailedSrc156Evid4903Params>
 */
export function aiBenchmarkTestFailedSrc156Evid4903(params: aiBenchmarkTestFailedSrc156Evid4903Params): LogObject<aiBenchmarkTestFailedSrc156Evid4903Params> {
  return { evid: 4903, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'aiUoUFormFillingLlmResponsePriceSrc156Evid4904' event (evid: 4904)
 *
 * Event description: For tracking LLM price for UoU filling a form
 *
 * @param {aiUoUFormFillingLlmResponsePriceSrc156Evid4904Params} params - The parameters for this event
 * @property {string} microcentsSpent - Then conversation price will be (summed microcent_spent by form_completion_id) * 1000 
 * @property {string} formCompletionId - form_completion_id
 * @property {string} formGuid - form_id / form_guid
 * @property {string} method - 'voice' for voice, currently null for text
 * @property {string} usageResponseJson - full llm response of usage, in json format, including tokens used etc (currently just for voice), e.g.:
 * "usage": {
 *             "total_tokens":275,
 *             "input_tokens":127,
 *             "output_tokens":148,
 *             "input_token_details": {
 *                   }
 *         }......
 * @property {number} totalTokens - total_tokens form llm response (currently just voice)
 * @property {number} inputTokens - input_tokens from llm response (currently just voice)
 * @property {number} outputTokens - output tokens from llm response (currently just voice)
 * @property {string} form_fill_session_id - form_fill_session_id to join other front end events for the same form filling session
 * @property {string} interactiveFormSessionId - interactive_form_session_id (previously form_completion_id)
 * @return {LogObject<aiUoUFormFillingLlmResponsePriceSrc156Evid4904Params>} LogObject<aiUoUFormFillingLlmResponsePriceSrc156Evid4904Params>
 */
export function aiUoUFormFillingLlmResponsePriceSrc156Evid4904(params: aiUoUFormFillingLlmResponsePriceSrc156Evid4904Params): LogObject<aiUoUFormFillingLlmResponsePriceSrc156Evid4904Params> {
  return { evid: 4904, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPagePageViewSrc156Evid5201' event (evid: 5201)
 *
 * Event description: Page fully loaded on Wild Forms Templates Page
 *
 * @param {wildFormsTemplatesPagePageViewSrc156Evid5201Params} params - The parameters for this event
 * @property {number} loading_time - in ms
 * @property {Url} referral_url - referral url
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} prefilled_info - whether the search bar was prefilled or not, and with which value
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} screen_name - template page / viewer
 * @property {string} session_id - session id for each visit
 * @property {string} page_name - which page the user saw - home / category / no results
 * @return {LogObject<wildFormsTemplatesPagePageViewSrc156Evid5201Params>} LogObject<wildFormsTemplatesPagePageViewSrc156Evid5201Params>
 */
export function wildFormsTemplatesPagePageViewSrc156Evid5201(params: wildFormsTemplatesPagePageViewSrc156Evid5201Params): LogObject<wildFormsTemplatesPagePageViewSrc156Evid5201Params> {
  return { evid: 5201, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPageHoverTemplateSrc156Evid5212' event (evid: 5212)
 *
 * Event description: hover over a template on templates page
 *
 * @param {wildFormsTemplatesPageHoverTemplateSrc156Evid5212Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category of the page
 * @property {string} sub_category - sub_category of the page
 * @property {string} micro_category - micro_category of the page
 * @property {string} template_id - id of the template being hovered
 * @property {string} screen_name - template page / viewer
 * @property {boolean} is_pro - is the template pro or not
 * @property {string} page_name - page name
 * @property {string} search_term - last search term the user had
 * @property {string} session_id - session id for each visit
 * @property {number} position_index - position_index
 * @property {number} json_id - json.  id
 * @return {LogObject<wildFormsTemplatesPageHoverTemplateSrc156Evid5212Params>} LogObject<wildFormsTemplatesPageHoverTemplateSrc156Evid5212Params>
 */
export function wildFormsTemplatesPageHoverTemplateSrc156Evid5212(params: wildFormsTemplatesPageHoverTemplateSrc156Evid5212Params): LogObject<wildFormsTemplatesPageHoverTemplateSrc156Evid5212Params> {
  return { evid: 5212, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPageEditTemplateSrc156Evid5215' event (evid: 5215)
 *
 * Event description: click edit a template on templates page
 *
 * @param {wildFormsTemplatesPageEditTemplateSrc156Evid5215Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} template_id - template id
 * @property {string} origin - origin
 * @property {string} screen_name - template page / viewer
 * @property {boolean} is_pro - is the template pro or not
 * @property {string} page_name - page name
 * @property {number} json_id - json id
 * @property {number} position_index - position_index
 * @property {string} search_term - last search term the user had
 * @property {string} session_id - session id for each visit
 * @return {LogObject<wildFormsTemplatesPageEditTemplateSrc156Evid5215Params>} LogObject<wildFormsTemplatesPageEditTemplateSrc156Evid5215Params>
 */
export function wildFormsTemplatesPageEditTemplateSrc156Evid5215(params: wildFormsTemplatesPageEditTemplateSrc156Evid5215Params): LogObject<wildFormsTemplatesPageEditTemplateSrc156Evid5215Params> {
  return { evid: 5215, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPageSearchSrc156Evid5224' event (evid: 5224)
 *
 * Event description: Searches on the templates page
 *
 * @param {wildFormsTemplatesPageSearchSrc156Evid5224Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} source - where the search was conducted
 * @property {string} criteria - the text input of the search
 * @property {string} search_type - free text / prefilled info
 * @property {string} screen_name - template page / viewer
 * @property {string} page_name - page name
 * @property {string} session_id - session id for each visit
 * @return {LogObject<wildFormsTemplatesPageSearchSrc156Evid5224Params>} LogObject<wildFormsTemplatesPageSearchSrc156Evid5224Params>
 */
export function wildFormsTemplatesPageSearchSrc156Evid5224(params: wildFormsTemplatesPageSearchSrc156Evid5224Params): LogObject<wildFormsTemplatesPageSearchSrc156Evid5224Params> {
  return { evid: 5224, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPageMenuInteractionsSrc156Evid5225' event (evid: 5225)
 *
 * Event description: interactions with the categories menu
 *
 * @param {wildFormsTemplatesPageMenuInteractionsSrc156Evid5225Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} button_name - button_name
 * @property {string} screen_name - template page / viewer
 * @property {string} page_name - page name
 * @property {string} session_id - session id for each visit
 * @property {string} button_type - button type
 * @return {LogObject<wildFormsTemplatesPageMenuInteractionsSrc156Evid5225Params>} LogObject<wildFormsTemplatesPageMenuInteractionsSrc156Evid5225Params>
 */
export function wildFormsTemplatesPageMenuInteractionsSrc156Evid5225(params: wildFormsTemplatesPageMenuInteractionsSrc156Evid5225Params): LogObject<wildFormsTemplatesPageMenuInteractionsSrc156Evid5225Params> {
  return { evid: 5225, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPageFilterInteractionsSrc156Evid5226' event (evid: 5226)
 *
 * Event description: interactions with the filters on Wild Forms Templates Page
 *
 * @param {wildFormsTemplatesPageFilterInteractionsSrc156Evid5226Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} click_type - click_type
 * @property {string} filter - on which filter user clicked
 * @property {string} value - chosen value / existing value
 * @property {string} screen_name - template page / viewer
 * @property {string} page_name - page name
 * @property {string} session_id - session id for each visit
 * @return {LogObject<wildFormsTemplatesPageFilterInteractionsSrc156Evid5226Params>} LogObject<wildFormsTemplatesPageFilterInteractionsSrc156Evid5226Params>
 */
export function wildFormsTemplatesPageFilterInteractionsSrc156Evid5226(params: wildFormsTemplatesPageFilterInteractionsSrc156Evid5226Params): LogObject<wildFormsTemplatesPageFilterInteractionsSrc156Evid5226Params> {
  return { evid: 5226, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPageGeneralActionSrc156Evid5242' event (evid: 5242)
 *
 * Event description: general actions on the Templates Page
 *
 * @param {wildFormsTemplatesPageGeneralActionSrc156Evid5242Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} section - section
 * @property {string} action - action
 * @property {string} location - location
 * @property {string} screen_name - template page / viewer
 * @property {string} session_id - session id for each visit
 * @property {number} position_index - position_index
 * @property {string} template_id - template_id
 * @return {LogObject<wildFormsTemplatesPageGeneralActionSrc156Evid5242Params>} LogObject<wildFormsTemplatesPageGeneralActionSrc156Evid5242Params>
 */
export function wildFormsTemplatesPageGeneralActionSrc156Evid5242(params: wildFormsTemplatesPageGeneralActionSrc156Evid5242Params): LogObject<wildFormsTemplatesPageGeneralActionSrc156Evid5242Params> {
  return { evid: 5242, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPageAboveTheFoldImpressionSrc156Evid5252' event (evid: 5252)
 *
 * Event description: When user saw a certain template on templates page
 *
 * @param {wildFormsTemplatesPageAboveTheFoldImpressionSrc156Evid5252Params} params - The parameters for this event
 * @property {string} book - book
 * @property {string} category - category
 * @property {number} page_index - page index
 * @property {string} Platform - platform
 * @property {string} template_id - template_id
 * @property {string} search_term - last search term the user had
 * @property {string} session_id - session id for each visit
 * @property {boolean} is_pro - is pro template
 * @property {string} sub_category - subcat
 * @property {string} micro_category - microcat
 * @property {number} position_index - position_index
 * @property {number} json_id - json_id
 * @property {string} fold_name - fold_name
 * @property {string} page_name - page_name
 * @return {LogObject<wildFormsTemplatesPageAboveTheFoldImpressionSrc156Evid5252Params>} LogObject<wildFormsTemplatesPageAboveTheFoldImpressionSrc156Evid5252Params>
 */
export function wildFormsTemplatesPageAboveTheFoldImpressionSrc156Evid5252(params: wildFormsTemplatesPageAboveTheFoldImpressionSrc156Evid5252Params): LogObject<wildFormsTemplatesPageAboveTheFoldImpressionSrc156Evid5252Params> {
  return { evid: 5252, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPageNavigationSrc156Evid5254' event (evid: 5254)
 *
 * Event description: navigation on the templates page
 *
 * @param {wildFormsTemplatesPageNavigationSrc156Evid5254Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} value - value
 * @property {string} screen_name - template page / viewer
 * @property {string} session_id - session id for each visit
 * @property {string} section - on which section the navigation was conducted. examples: popular categories, breadcrumbs
 * @return {LogObject<wildFormsTemplatesPageNavigationSrc156Evid5254Params>} LogObject<wildFormsTemplatesPageNavigationSrc156Evid5254Params>
 */
export function wildFormsTemplatesPageNavigationSrc156Evid5254(params: wildFormsTemplatesPageNavigationSrc156Evid5254Params): LogObject<wildFormsTemplatesPageNavigationSrc156Evid5254Params> {
  return { evid: 5254, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPagePaginationSrc156Evid5255' event (evid: 5255)
 *
 * Event description: Pagination on Templates Page
 *
 * @param {wildFormsTemplatesPagePaginationSrc156Evid5255Params} params - The parameters for this event
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {number} page_clicked - target page
 * @property {string} campagins_data - example: button
 * @property {string} screen_name - template page / viewer
 * @property {string} session_id - session id for each visit
 * @return {LogObject<wildFormsTemplatesPagePaginationSrc156Evid5255Params>} LogObject<wildFormsTemplatesPagePaginationSrc156Evid5255Params>
 */
export function wildFormsTemplatesPagePaginationSrc156Evid5255(params: wildFormsTemplatesPagePaginationSrc156Evid5255Params): LogObject<wildFormsTemplatesPagePaginationSrc156Evid5255Params> {
  return { evid: 5255, src: 156, endpoint: '', params };
}

/**
 * A function to create a log object for the 'wildFormsTemplatesPagePageViewSrc181Evid5201' event (evid: 5201)
 *
 * Event description: Page fully loaded on Wixel Templates Page
 *
 * @param {wildFormsTemplatesPagePageViewSrc181Evid5201Params} params - The parameters for this event
 * @property {number} loading_time - in ms
 * @property {Url} referral_url - referral url
 * @property {string} platform - on which platform the page is being viewed
 * @property {string} prefilled_info - whether the search bar was prefilled or not, and with which value
 * @property {string} book - book
 * @property {number} page_index - on which page index we viewed the screen
 * @property {string} category - category
 * @property {string} sub_category - sub_category
 * @property {string} micro_category - micro_category
 * @property {string} screen_name - template page / viewer
 * @property {string} session_id - session id for each visit
 * @property {string} page_name - which page the user saw - home / category / no results
 * @return {LogObject<wildFormsTemplatesPagePageViewSrc181Evid5201Params>} LogObject<wildFormsTemplatesPagePageViewSrc181Evid5201Params>
 */
export function wildFormsTemplatesPagePageViewSrc181Evid5201(params: wildFormsTemplatesPagePageViewSrc181Evid5201Params): LogObject<wildFormsTemplatesPagePageViewSrc181Evid5201Params> {
  return { evid: 5201, src: 181, endpoint: '', params };
}

/**
 * A function to create a log object for the 'spamFilterManage' event (evid: 124102)
 *
 * Event description: Event to track create/update/delete events
 *
 * @param {spamFilterManageParams} params - The parameters for this event
 * @property {string} visitorId - Visitor ID
 * @property {string} appDefId - AppDefId
 * @property {string} fieldValue - Value of the filter
 * @property {string} filterId - UUID of the filter
 * @property {string} actionName - create/update/delete
 * @property {string} fieldType - Type of the filter such as "IP", "FREE_TEXT"
 * @property {string} boUser - Back Office user identifier
 * @property {string} msid - Meta site ID
 * @return {LogObject<spamFilterManageParams>} LogObject<spamFilterManageParams>
 */
export function spamFilterManage(params: spamFilterManageParams): LogObject<spamFilterManageParams> {
  return { evid: 124102, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formBuilderSubmissionSent' event (evid: 2300)
 *
 * Event description: Submission sent successfully by UoU via wix form or contact form, include standalone forms
 *
 * @param {formBuilderSubmissionSentParams} params - The parameters for this event
 * @property {string} formName - form name
 * @property {number} numOfAttachments - number of attachments, 0 if none
 * @property {string} appName - app name
 * @property {GUID} visitor_id - visitor id
 * @property {string} emailHash - Hash of the UoU email
 * @property {GUID} submissionId - submission Id
 * @property {string} form_comp_id - wix form id (per msid)
 * @property {string} origin - 'submit-v2' for Standalone form, 'web' or null for website forms
 * @property {boolean} isBot - is bot detected
 * @property {number} numOfFields - num of submitted fields
 * @property {GUID} msid - msid
 * @return {LogObject<formBuilderSubmissionSentParams>} LogObject<formBuilderSubmissionSentParams>
 */
export function formBuilderSubmissionSent(params: formBuilderSubmissionSentParams): LogObject<formBuilderSubmissionSentParams> {
  return { evid: 2300, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formBuilderSubmissionFailed' event (evid: 2301)
 *
 * Event description: Form Submission Failed (wix form or contact form)
 *
 * @param {formBuilderSubmissionFailedParams} params - The parameters for this event
 * @property {number} numOfAttachments - number of attachments, 0 if none
 * @property {string} appName - app name
 * @property {GUID} visitor_id - visitor id
 * @property {string} reason - reason type
 * @property {string} reason_body - reason details
 * @property {string} form_comp_id - wix form id (per msid)
 * @property {string} origin - web/mobile
 * @property {number} numOfFields - num of submitted fields
 * @property {GUID} msid - msid
 * @return {LogObject<formBuilderSubmissionFailedParams>} LogObject<formBuilderSubmissionFailedParams>
 */
export function formBuilderSubmissionFailed(params: formBuilderSubmissionFailedParams): LogObject<formBuilderSubmissionFailedParams> {
  return { evid: 2301, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formsEmailOpensFormSubmissionEmails' event (evid: 2304)
 *
 * Event description: Forms email - opens form submission emails
 *
 * @param {formsEmailOpensFormSubmissionEmailsParams} params - The parameters for this event
 * @property {string} eventType - eventType
 * @property {string} custom_fields - custom_fields
 * @property {DateTime} timestamp - timestamp
 * @property {string} url - url
 * @property {string} user_agent - user_agent
 * @property {string} appDefId - appDefId
 * @property {string} messageType - messageType
 * @property {GUID} contactId - contactId
 * @property {string} messageLng - messageLng
 * @property {GUID} msid - msid
 * @return {LogObject<formsEmailOpensFormSubmissionEmailsParams>} LogObject<formsEmailOpensFormSubmissionEmailsParams>
 */
export function formsEmailOpensFormSubmissionEmails(params: formsEmailOpensFormSubmissionEmailsParams): LogObject<formsEmailOpensFormSubmissionEmailsParams> {
  return { evid: 2304, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formBuilderSubmissionIgnored' event (evid: 2313)
 *
 * Event description: an event that states if a submission was ignored on purpose, to prevent fraud.
 *
 * @param {formBuilderSubmissionIgnoredParams} params - The parameters for this event
 * @property {GUID} submissionId - submission id
 * @property {string} reason - why submission was ignored
 * @property {string} form_comp_id - form component id
 * @property {string} ipAddress - ip address
 * @property {string} reason_metadata - reason additional info
 * @property {GUID} msid - msid
 * @return {LogObject<formBuilderSubmissionIgnoredParams>} LogObject<formBuilderSubmissionIgnoredParams>
 */
export function formBuilderSubmissionIgnored(params: formBuilderSubmissionIgnoredParams): LogObject<formBuilderSubmissionIgnoredParams> {
  return { evid: 2313, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formBuilderSubmissionMarkedAsSpam' event (evid: 2314)
 *
 * Event description: Indicates if the submission was marked as spam
 *
 * @param {formBuilderSubmissionMarkedAsSpamParams} params - The parameters for this event
 * @property {string} email - Hashed email
 * @property {string} formCompId - Form id
 * @property {GUID} submissionId - Submission id
 * @property {string} reason - Reason as as Blocked IP
 * @property {string} ipAddress - IP address, if relevant
 * @property {string} reasonMetadata - More info about the blocker service, such as ID of the relevant spam filter entity
 * @property {GUID} msid - MetaSite id
 * @return {LogObject<formBuilderSubmissionMarkedAsSpamParams>} LogObject<formBuilderSubmissionMarkedAsSpamParams>
 */
export function formBuilderSubmissionMarkedAsSpam(params: formBuilderSubmissionMarkedAsSpamParams): LogObject<formBuilderSubmissionMarkedAsSpamParams> {
  return { evid: 2314, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formBuilderReportSpam' event (evid: 2315)
 *
 * Event description: Action by user to mark submission as spam
 *
 * @param {formBuilderReportSpamParams} params - The parameters for this event
 * @property {string} hashedEmail - Hashed email
 * @property {string} hashedEmailDomain - Hashed email domain
 * @property {number} freeTextLength - Free text length
 * @property {GUID} submissionId - Submission ID
 * @property {string} hashedFreeText - Hashed free text
 * @property {GUID} msid - MSID
 * @return {LogObject<formBuilderReportSpamParams>} LogObject<formBuilderReportSpamParams>
 */
export function formBuilderReportSpam(params: formBuilderReportSpamParams): LogObject<formBuilderReportSpamParams> {
  return { evid: 2315, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'captchaEnforcerEvents' event (evid: 2316)
 *
 * Event description: Records when enforced captcha was required, passed or failed to pass
 *
 * @param {captchaEnforcerEventsParams} params - The parameters for this event
 * @property {string} result - required/passed/failed
 * @property {GUID} submissionId - Submission ID
 * @property {GUID} msid - Metasite ID
 * @return {LogObject<captchaEnforcerEventsParams>} LogObject<captchaEnforcerEventsParams>
 */
export function captchaEnforcerEvents(params: captchaEnforcerEventsParams): LogObject<captchaEnforcerEventsParams> {
  return { evid: 2316, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'submissionPassedValidation' event (evid: 2317)
 *
 * Event description: Submission passed validation stage
 *
 * @param {submissionPassedValidationParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {GUID} submissionId - submission Id
 * @return {LogObject<submissionPassedValidationParams>} LogObject<submissionPassedValidationParams>
 */
export function submissionPassedValidation(params: submissionPassedValidationParams): LogObject<submissionPassedValidationParams> {
  return { evid: 2317, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formsActionsAfterSubmissionsContactCreated' event (evid: 2320)
 *
 * Event description: contact created after a form submission
 *
 * @param {formsActionsAfterSubmissionsContactCreatedParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} formCompId - Form id
 * @property {GUID} submissionId - submissionId
 * @property {string} contactId - contact_id
 * @property {GUID} msid - MetaSite id
 * @return {LogObject<formsActionsAfterSubmissionsContactCreatedParams>} LogObject<formsActionsAfterSubmissionsContactCreatedParams>
 */
export function formsActionsAfterSubmissionsContactCreated(params: formsActionsAfterSubmissionsContactCreatedParams): LogObject<formsActionsAfterSubmissionsContactCreatedParams> {
  return { evid: 2320, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formsActionsAfterSubmissionsSubmissionProcessed' event (evid: 2321)
 *
 * Event description: Forms - actions after submissions - submission processed.
 *
 * @param {formsActionsAfterSubmissionsSubmissionProcessedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} formCompId - Form id
 * @property {GUID} submissionId - submissionId
 * @property {string} contactId - contact_id
 * @property {string} actionName - ex. 'email sent', 'ping sent', 'inbox msg sent'
 * @property {GUID} msid - msid
 * @return {LogObject<formsActionsAfterSubmissionsSubmissionProcessedParams>} LogObject<formsActionsAfterSubmissionsSubmissionProcessedParams>
 */
export function formsActionsAfterSubmissionsSubmissionProcessed(params: formsActionsAfterSubmissionsSubmissionProcessedParams): LogObject<formsActionsAfterSubmissionsSubmissionProcessedParams> {
  return { evid: 2321, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formsPaymentFormUserConnectPaymentToAForm' event (evid: 2322)
 *
 * Event description: (Note: the event is triggered only when a site is publish) user connect/disconnect payment to a form
 *
 * @param {formsPaymentFormUserConnectPaymentToAFormParams} params - The parameters for this event
 * @property {string} formIdArray - form_id of the connected payment form
 * @property {boolean} hasPaymentPlugin - Is the site connected to payment form?
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @return {LogObject<formsPaymentFormUserConnectPaymentToAFormParams>} LogObject<formsPaymentFormUserConnectPaymentToAFormParams>
 */
export function formsPaymentFormUserConnectPaymentToAForm(params: formsPaymentFormUserConnectPaymentToAFormParams): LogObject<formsPaymentFormUserConnectPaymentToAFormParams> {
  return { evid: 2322, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formBuilderBackofficeFormSubmissionSentServer' event (evid: 6601)
 *
 * Event description: Server event - UoU submit a backoffice form
 *
 * @param {formBuilderBackofficeFormSubmissionSentServerParams} params - The parameters for this event
 * @property {string} form_comp_id - form_comp_id
 * @property {GUID} msid - msid
 * @return {LogObject<formBuilderBackofficeFormSubmissionSentServerParams>} LogObject<formBuilderBackofficeFormSubmissionSentServerParams>
 */
export function formBuilderBackofficeFormSubmissionSentServer(params: formBuilderBackofficeFormSubmissionSentServerParams): LogObject<formBuilderBackofficeFormSubmissionSentServerParams> {
  return { evid: 6601, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formBuilderBackofficeFormSubmissionReceivedSuccessfullyServer' event (evid: 6602)
 *
 * Event description: Server event - UoU submit a backoffice form successfully
 *
 * @param {formBuilderBackofficeFormSubmissionReceivedSuccessfullyServerParams} params - The parameters for this event
 * @property {string} form_name - form_name
 * @property {string} form_comp_id - form_comp_id
 * @property {GUID} msid - msid
 * @return {LogObject<formBuilderBackofficeFormSubmissionReceivedSuccessfullyServerParams>} LogObject<formBuilderBackofficeFormSubmissionReceivedSuccessfullyServerParams>
 */
export function formBuilderBackofficeFormSubmissionReceivedSuccessfullyServer(params: formBuilderBackofficeFormSubmissionReceivedSuccessfullyServerParams): LogObject<formBuilderBackofficeFormSubmissionReceivedSuccessfullyServerParams> {
  return { evid: 6602, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'formBuilderBackofficeFormSubmissionFailedServer' event (evid: 6603)
 *
 * Event description: Server event - UoU submit a backoffice form and the submission failed
 *
 * @param {formBuilderBackofficeFormSubmissionFailedServerParams} params - The parameters for this event
 * @property {string} form_name - form_name
 * @property {string} form_comp_id - form_comp_id
 * @property {string} error_reason - error_reason
 * @property {GUID} msid - msid
 * @return {LogObject<formBuilderBackofficeFormSubmissionFailedServerParams>} LogObject<formBuilderBackofficeFormSubmissionFailedServerParams>
 */
export function formBuilderBackofficeFormSubmissionFailedServer(params: formBuilderBackofficeFormSubmissionFailedServerParams): LogObject<formBuilderBackofficeFormSubmissionFailedServerParams> {
  return { evid: 6603, src: 19, endpoint: '', params };
}

/**
 * A function to create a log object for the 'inputElementsAppointmentFieldSettingsClickOnButton' event (evid: 4801)
 *
 * Event description: Input elements - appointment field settings - click on button.
 *
 * @param {inputElementsAppointmentFieldSettingsClickOnButtonParams} params - The parameters for this event
 * @property {string} fieldName - fieldName
 * @property {string} buttonName - buttonName
 * @property {GUID} msid - msid
 * @property {string} inputType - input_type
 * @return {LogObject<inputElementsAppointmentFieldSettingsClickOnButtonParams>} LogObject<inputElementsAppointmentFieldSettingsClickOnButtonParams>
 */
export function inputElementsAppointmentFieldSettingsClickOnButton(params: inputElementsAppointmentFieldSettingsClickOnButtonParams): LogObject<inputElementsAppointmentFieldSettingsClickOnButtonParams> {
  return { evid: 4801, src: 5, endpoint: '', params };
}

/**
 * A function to create a log object for the 'inputElementsAppointmentFieldSettingsChangeValue' event (evid: 4802)
 *
 * Event description: the user change value in the settings of the appointment (and time zone) field in the editor.
 * include chequebook, radio button, text input etc
 *
 * @param {inputElementsAppointmentFieldSettingsChangeValueParams} params - The parameters for this event
 * @property {string} previousValue - previous Value
 * @property {string} fieldName - fieldName
 * @property {string} fieldType - radio/checkbox/toggle etc
 * @property {GUID} msid - msid
 * @property {string} inputType - appointment or time zone
 * @property {string} value - new value
 * @return {LogObject<inputElementsAppointmentFieldSettingsChangeValueParams>} LogObject<inputElementsAppointmentFieldSettingsChangeValueParams>
 */
export function inputElementsAppointmentFieldSettingsChangeValue(params: inputElementsAppointmentFieldSettingsChangeValueParams): LogObject<inputElementsAppointmentFieldSettingsChangeValueParams> {
  return { evid: 4802, src: 5, endpoint: '', params };
}

/**
 * A function to create a log object for the 'membersClickOnSaveInTheChangeSiteMemberLoginEmailModal' event (evid: 898)
 *
 * Event description: The user clicks on save in the change site member login email modal
 *
 * @param {membersClickOnSaveInTheChangeSiteMemberLoginEmailModalParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} vsi - vsi
 * @property {GUID} contact_id - contact_id of the site member whose email was changed
 * @property {string} platform - platform
 * @return {LogObject<membersClickOnSaveInTheChangeSiteMemberLoginEmailModalParams>} LogObject<membersClickOnSaveInTheChangeSiteMemberLoginEmailModalParams>
 */
export function membersClickOnSaveInTheChangeSiteMemberLoginEmailModal(params: membersClickOnSaveInTheChangeSiteMemberLoginEmailModalParams): LogObject<membersClickOnSaveInTheChangeSiteMemberLoginEmailModalParams> {
  return { evid: 898, src: 5, endpoint: '', params };
}
